<template>
  <div
    class="vx-card mol-card-interaction"
    :class="{ selected: isSelected }"
    @click="jumpToEquipmentVessel(vesselInfoForJump)"
  >
    <vs-row class="mb-1">
      <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="12">
        <span class="aisea-text-16-600-white truncate">
          {{ vesselName }}
        </span>
      </vs-col>
    </vs-row>
    <vs-row class="mb-2">
      <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="12">
        <text-box :backgroundColor="statusColor" :text="vesselOperations" />
      </vs-col>
    </vs-row>
    <ul>
      <li>
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 積載物 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ category }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 積載量 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ value }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 目的地 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ destination }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 積込完了日時 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ loadingCompletionDatetime }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 出発時刻 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ departureDatetime }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 到着予定日時 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ lastPredictTime.time }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 投入開始日時 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ inputStartDatetime }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 投入完了日時 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ inputCompetionDatetime }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-600-white"> 更新日時 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <span class="aisea-text-12-300-white truncate">
              {{ updatedAt }}
            </span>
          </vs-col>
        </vs-row>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * 作業船のカードを描画するコンポーネント
 * @parent O.VesselEquipmentBaseStations
 * @parent O.EquipmentBaseStation
 * @props vessel: Object 船情報オブジェクト
 * @props jumpToEquipmentVessel: Function 運搬船の座標に移動する関数
 * @props isSelected: 選択中カードのフラグ
 */
import * as Enum from "@/config/const.js";
import {
  getEquipmentVesselStatusColor,
  getPredictArrivalTime,
} from "@/utils/VesselUtil";
import moment from "moment";
import TextBox from "@/components/atoms/TextBox";

export default {
  name: "M.EquipmentVesselCard",
  components: {
    TextBox,
  },
  props: {
    vessel: {
      type: Object,
      default: null,
    },
    jumpToEquipmentVessel: {
      type: Function,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    seaRoute: {
      type: Array,
      default: () => [],
    },
    isDebug: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultValues: {
        noneDate: "---",
        noneData: "-",
        noneText: "",
      },
      lastPredictTime: {
        time: null,
      },
      interval: null,
    };
  },
  mounted() {
    const intervalTime = this.isDebugForCard ? 1000 : 60000;
    this.$nextTick(() => {
      // 最初の一回は即時実行
      this.predictArrivalTime();
      // 2回目からは定期実行
      this.interval = setInterval(() => {
        this.predictArrivalTime();
      }, intervalTime);
    });
  },
  beforeDestroy() {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
  },
  computed: {
    // デバッグフラグは親コンポーネントで非同期処理しているので
    // 変更を検知できるようにする
    isDebugForCard() {
      return this.isDebug;
    },
    // 船名
    vesselName() {
      if (!this.vessel) return this.defaultValues.noneText;
      if (!this.vessel.vesselDetail) return this.defaultValues.noneText;
      const vesselDetail = this.vessel.vesselDetail;
      const vesselName = vesselDetail.name_ja
        ? vesselDetail.name_ja
        : vesselDetail.name
        ? vesselDetail.name
        : this.defaultValues.noneText;
      return vesselName;
    },
    // 航行状況
    vesselOperations() {
      if (!this.vessel) return this.defaultValues.noneData;
      const enumProperty =
        Enum.EQUIPMENT_VESSEL_STATUS.properties[String(this.vessel.status)];
      if (!enumProperty) return this.defaultValues.noneData;
      return enumProperty.label;
    },
    // 航行状況ステータカラー
    statusColor() {
      if (!this.vessel) return getEquipmentVesselStatusColor(null);
      return this.vessel.status != null
        ? getEquipmentVesselStatusColor(this.vessel.status)
        : getEquipmentVesselStatusColor(null);
    },
    // 積載物
    category() {
      if (!this.vessel) return this.defaultValues.noneData;
      return this.vessel.categoryLabel || this.defaultValues.noneData;
    },
    // 積載量
    value() {
      if (!this.vessel) return this.defaultValues.noneData;
      if (!this.vessel.data) return this.defaultValues.noneData;
      return this.vessel.data.value != null && this.vessel.unit
        ? `${this.vessel.data.value.toLocaleString()}${this.unit}`
        : this.defaultValues.noneData;
    },
    // 表示する単位
    unit() {
      if (!this.vessel) return this.defaultValues.noneText;
      if (!this.vessel.unit) return this.defaultValues.noneText;
      if (this.vessel.unit === "m3") return "㎥";
      return this.vessel.unit;
    },
    // 目的地
    destination() {
      if (!this.vessel) return this.defaultValues.noneData;
      return this.vessel.destinationLabel || this.defaultValues.noneData;
    },
    // 積込完了日時
    loadingCompletionDatetime() {
      if (!this.vessel) return this.defaultValues.noneDate;
      if (!this.vessel.data) return this.defaultValues.noneDate;
      if (!this.vessel.data.loading_completion_datetime)
        return this.defaultValues.noneDate;
      return this.vessel.data.loading_completion_datetime.seconds != null
        ? moment(
            this.vessel.data.loading_completion_datetime.seconds * 1000,
          ).format("YYYY/MM/DD HH:mm")
        : this.defaultValues.noneDate;
    },
    // 出発時刻
    departureDatetime() {
      if (!this.vessel) return this.defaultValues.noneDate;
      if (!this.vessel.data) return this.defaultValues.noneDate;
      if (!this.vessel.data.departure_datetime)
        return this.defaultValues.noneDate;
      return this.vessel.data.departure_datetime.seconds != null
        ? moment(this.vessel.data.departure_datetime.seconds * 1000).format(
            "YYYY/MM/DD HH:mm",
          )
        : this.defaultValues.noneDate;
    },
    // 投入開始時刻
    inputStartDatetime() {
      if (!this.vessel) return this.defaultValues.noneDate;
      if (!this.vessel.data) return this.defaultValues.noneDate;
      if (!this.vessel.data.input_start_datetime)
        return this.defaultValues.noneDate;
      return this.vessel.data.input_start_datetime.seconds != null
        ? moment(this.vessel.data.input_start_datetime.seconds * 1000).format(
            "YYYY/MM/DD HH:mm",
          )
        : this.defaultValues.noneDate;
    },
    // 投入完了日時
    inputCompetionDatetime() {
      if (!this.vessel) return this.defaultValues.noneDate;
      if (!this.vessel.data) return this.defaultValues.noneDate;
      if (!this.vessel.data.input_completion_datetime)
        return this.defaultValues.noneDate;
      return this.vessel.data.input_completion_datetime.seconds != null
        ? moment(
            this.vessel.data.input_completion_datetime.seconds * 1000,
          ).format("YYYY/MM/DD HH:mm")
        : this.defaultValues.noneDate;
    },
    // 更新日時
    updatedAt() {
      if (!this.vessel) return this.defaultValues.noneDate;
      if (!this.vessel.data) return this.defaultValues.noneDate;
      if (!this.vessel.data.timestamp) return this.defaultValues.noneDate;
      if (!this.vessel.data.timestamp.seconds)
        return this.defaultValues.noneDate;
      return moment(this.vessel.data.timestamp.seconds * 1000).format(
        "YYYY/MM/DD HH:mm",
      );
    },
    // jumpToEquipmentVessel関数用の引数
    vesselInfoForJump() {
      if (!this.vessel) {
        return null;
      }
      return {
        vesselId: this.vessel.vessel_id,
        vesselPosition: this.vessel.vesselPosition,
      };
    },
  },
  methods: {
    // 到着予定時刻を計算する
    predictArrivalTime() {
      // 船舶の座標
      const vesselPoint =
        this.vessel.vesselPosition && this.vessel.vesselPosition.l
          ? [
              this.vessel.vesselPosition.l.latitude,
              this.vessel.vesselPosition.l.longitude,
            ]
          : [];
      // 船速
      const speed = this.vessel.vesselPosition
        ? this.vessel.vesselPosition.v
        : null;
      // 平均船速
      const averageSpeed = this.vessel.average_speed;
      // 到着予定時刻
      this.lastPredictTime = getPredictArrivalTime(
        this.seaRoute,
        speed,
        vesselPoint,
        averageSpeed,
        this.departureDatetime,
        this.isDebugForCard && this.vessel.vessel_id === "24657",
      );
      // [TODO] デバッグが終わったら削除する
      // デバッグ用(テスト用船舶ID=24657)
      if (this.isDebugForCard && this.vessel.vessel_id === "24657") {
        console.log(
          `${this.vesselName}
            ArrivalTime: ${this.lastPredictTime.time}`,
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.vx-card {
  background: $aisea-blue-gray;
  cursor: pointer;
  width: 360px;
  padding: 14px;
  margin: 0 auto;
}

.mol-card-interaction {
  background-color: $aisea-blue-gray;
  &:hover {
    background-color: #6a717d;
  }
  &:active {
    background-color: #969ba4;
  }
}

.mol-card-interaction.selected {
  background-color: #1b5e83;
  outline: 2px solid #2d9cdb;

  &:hover {
    background-color: #588eac;
  }
  &:active {
    background-color: #98b6c7;
  }
}
</style>
